var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNotifyOnScanWorkflow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#5777EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.666 11.334a1.667 1.667 0 100 3.333 1.667 1.667 0 000-3.333z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.667 8.108v6.72c0 .537 0 .98.029 1.34.03.375.096.72.261 1.043.256.502.664.91 1.166 1.166.323.165.668.23 1.042.26.361.03.804.03 1.34.03h6.989c.537 0 .98 0 1.34-.03.375-.03.72-.096 1.043-.26.502-.256.91-.664 1.166-1.166.164-.323.23-.668.26-1.042.03-.361.03-.804.03-1.34v-2.99c0-.536 0-.979-.03-1.34-.03-.374-.096-.719-.26-1.042a2.666 2.666 0 00-1.166-1.166c-.323-.165-.668-.23-1.043-.26-.36-.03-.803-.03-1.34-.03h-2.415l-.597-1.193c-.176-.354-.332-.666-.573-.903a2 2 0 00-.748-.462c-.32-.11-.668-.11-1.063-.109H7.44c-.352 0-.655 0-.905.02-.263.022-.525.07-.777.198a2 2 0 00-.875.874 2.036 2.036 0 00-.197.778c-.02.25-.02.553-.02.904zm6.06-1.404c-.08-.028-.185-.037-.712-.037H7.467c-.385 0-.633.001-.822.016-.181.015-.248.04-.281.057a.667.667 0 00-.292.291c-.016.033-.041.1-.056.282A9.278 9.278 0 006 8h5.588l-.261-.523c-.236-.471-.29-.56-.351-.62a.667.667 0 00-.25-.154zM8.666 13a3 3 0 115.54 1.597l.598.598a.667.667 0 01-.943.943l-.598-.598A3 3 0 018.667 13z",
    fill: "#fff"
  })));
}
export default SvgIconNotifyOnScanWorkflow;